// extracted by mini-css-extract-plugin
module.exports = {"section":"homepage-trending-mixes_section_1Hqcx"};